export const CHANGE_LANGUAGE = "COMMON:CHANGE_LANGUAGE"
